import * as types from '../actiontypes';

export function getEngagementRoles(url, resource) {
	return {
		type: types.GET_ALL_ENGAGEMENT_USER_ROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: { resource: resource }
			}
		}
	};
}

export function getRbacRoles(url, resource) {
	return {
		type: types.GET_ALL_RBAC_USER_ROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: { resource: resource }
			}
		}
	};
}